import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { RemoveLocationUser } from 'domain/usecases/remove-location-user';
import { RemoteRemoveLocationUser } from 'data/usecases/remove-location-user';

export const makeRemoteRemoveLocationUser = (): RemoveLocationUser => {
  return new RemoteRemoveLocationUser(makeApiUrl('/removeLocationUser'), makeAuthorizeHttpClientDecorator());
};
